import { httpRequest } from "../../http";
import { CatalogMetricType, MetricTypeIn } from "@models/catalog.model";

const COLL = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/metric-types/`;

export class CommandCreateMetricType {
  async run(payload: MetricTypeIn): Promise<CatalogMetricType> {
    return httpRequest<CatalogMetricType>(COLL, { method: "POST", body: payload });
  }
}

export class CommandUpdateMetricType {
  async run(id: number, payload: MetricTypeIn): Promise<CatalogMetricType> {
    return httpRequest<CatalogMetricType>(`${COLL}${id}/`, { method: "PUT", body: payload });
  }
}

export class CommandDeleteMetricType {
  async run(id: number): Promise<void> {
    await httpRequest(`${COLL}${id}/`, { method: "DELETE" });
  }
}
